import React, {useEffect, useState} from 'react';
import {ArtistDTO} from '../../spotipitan/types';
import PlaylistList from '../../../shared/playlist-list';
import useUserStore from '../../../../store/UserState';
import {useNavigate} from 'react-router-dom';
import {getPlaylistBdStatus, getPlaylistsFromDB} from '../../../../utils/dbUtils';

const OfflinePlaylists = () => {
    const [playlists, setPlaylists] = useState<ArtistDTO[]>([]);
    const [loading, setLoading] = useState(true);
    const {user, offlineMode} = useUserStore(state => state.state);
    const navigate = useNavigate();

    const onSetPlaylists = async (playlists: ArtistDTO[], method: (playlists: ArtistDTO[]) => void) => {

        const processedPlaylists: ArtistDTO[] = [];

        for (const playlist of playlists) {
            const processedPlaylist = { ...playlist };
            processedPlaylist.downloaded_status = await getPlaylistBdStatus(playlist.id);
            processedPlaylists.push(processedPlaylist);
        }

        method([...processedPlaylists]);
    }

    useEffect(() => {
        if (offlineMode) {
            getPlaylistsFromDB().then((playlists) => {
                onSetPlaylists(playlists, setPlaylists)
            }).catch((error) => {
                console.error("Error fetching offline playlists:", error)
                setPlaylists([])
            });;
            setLoading(false);
        }
    }, [user, offlineMode]);

    if (loading) {
        return (
            <div className="container">
                <div className="d-flex justify-content-center align-items-center" style={{height: '200px'}}>
                    <div className="spinner-border text-light" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        );
    }

    if (!playlists.length) {
        return (
            <div className="container">
                <div className="d-flex justify-content-center align-items-center" style={{height: '200px'}}>
                    <h4 className="text-light">No tienes playlists descargadas</h4>
                </div>
            </div>
        );
    }

    return (
        <div className="container">
            <div className="d-flex align-items-center mb-4">
                <h2 className="mb-0">Listas Offline</h2>
            </div>
            <PlaylistList
                inputPlaylists={playlists}
                onPlaylistClick={(playlist) => navigate(`/playlist/${playlist.id}`)}
                offlineMode={true}
            />
        </div>
    );
};

export default OfflinePlaylists; 
